import React from "react";

const ToggleButton = ({
                               className,
                               label,
                               disabled,
                               id,
                               onChange,
                               checked,
                               title = "",
                               required,
                               classNameLabel
                           }) => {

    const handleClick = () => {
        if (disabled) return;
        onChange?.(!checked);
    };

    return (
        <div
            className={[
                "flex items-center gap-2",
                disabled && "opacity-60",
                className
            ].join(" ")}
            title={title}
        >
            <button
                type="button"
                id={id}
                disabled={disabled}
                onClick={handleClick}
                className={[
                    "border-[1px] border-[#e5e7eb] flex justify-center cursor-pointer items-center gap-1 focus:outline-none rounded-md text-[13px] px-2 py-1 text-center disabled:bg-gray-200 disabled:pointer-events-none disabled:opacity-70",
                    checked
                        ? "text-white bg-[#063A6C] hover:bg-blue-800 focus:ring-blue-300 disabled:hover:bg-blue-700"
                        : "text-gray-700 bg-white hover:bg-gray-200 focus:ring-0 disabled:hover::bg-white",
                    disabled && "cursor-not-allowed",
                ].join(" ")}
            >
                {label}
            </button>
        </div>
    );
};

export default ToggleButton;
